export const environment = {
  production: true,
  apiUrl: 'https://progettocrespi.informabm.com/api',
  url: 'https://progettocrespi.informabm.com',
  domain: 'progettocrespi.informabm',
  env: 'prod',
};
